import { StringKeyDictionary } from "../commonInterfaces";

export const getInternalSearchContextApps = (): StringKeyDictionary<DynamicSearchContextHook> => {
    const result: StringKeyDictionary<DynamicSearchContextHook> = {};

    return result;
}

//Beispiel
//export class AddressSearchContext implements DynamicSearchContextHook {
//    constructor() {
//    };

//    //keine fat arrow Funktionen! (Ableitung wird nicht mehr funktionieren)
//    onCommandClick(cmdName, dataItem, tools) {
//        console.log("internal hook. cmd = " + cmdName);
//    }
//}



interface DynamicSearchContextHookCallbackTools {
    reloadData: () => void;
}
export interface DynamicSearchContextHook {
    onCommandClick: (cmdName: string, dataItem: any, tools: DynamicSearchContextHookCallbackTools) => void;
}
